import React, { useEffect, useState } from 'react';
import history from '../../utils/history';
import './navigation.scss';

export const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleAnchorClick = (e, href) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleWhitePaperClick = (e) => {
    e.preventDefault();
    history.push('/white-paper');
  };

  const handleLogoClick = (e) => {
    e.preventDefault();
    history.push('/');
  };

  const handleHomeClick = (e) => {
    e.preventDefault();
    history.push('/home');
  };

  return (
    <nav className={`navigation ${scrolled ? 'navigation--scrolled' : ''}`} id="nav">
      <a href="/" className="navigation__logo" onClick={handleLogoClick}>
        The Pearl
      </a>
      <div className="navigation__links">
        <a href="#crisis" onClick={(e) => handleAnchorClick(e, '#crisis')}>
          Team
        </a>
        <a href="/home" onClick={handleHomeClick}>
          The Pearl AI
        </a>
        <a href="/white-paper" onClick={handleWhitePaperClick}>
          White Paper
        </a>
      </div>
    </nav>
  );
};

